import { useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../pages/App/routes";
import CustomButton from "../../UI/Buttons/CustomButton";
import PersonID from "../../UI/Icons/PersonID";

const CandidateProfiles = ({
  stage_1_review,
  stage_2_review,
  stage_3_review,
  edit_request_count,
  compliance_alerts_count,
  compliance_alerts_review_count

}: {
  stage_1_review: number;
  stage_2_review: number;
  stage_3_review: number;
  edit_request_count: number;
  compliance_alerts_count: number;
  compliance_alerts_review_count: number;
}) => {
  const navigate = useNavigate();

  const handleViewClick = () => {
    navigate(AUTH_ROUTE.ADMIN_CANDIDATES);
  };

  return (
    <div className="border border-grey-light radius-8px p-10px d-flex flex-column gap-10">
      {/* Header */}
      <div className="d-flex flex-column flex-lg-row gap-3 gap-mobile-20 align-items-lg-center justify-content-lg-between">
        <div className="d-flex gap-3 align-items-center">
          <PersonID />
          <div className="w-15px"></div>
          <div className="d-flex flex-column flex-lg-row gap-3 align-items-lg-center">
            <div className="fs-45 fw-400 text-black">
              {stage_1_review + stage_2_review + stage_3_review + edit_request_count + compliance_alerts_review_count}
            </div>
            <div className="w-5px" />
            <div className="fs-16 fw-700 text-black">
              Employee Profiles To Review
            </div>
          </div>
        </div>
        <CustomButton
          variant={"primary"}
          type="button"
          className="btn-theme bg-off-white text-black max-h-30px"
          onClick={handleViewClick}
        >
          View
        </CustomButton>
      </div>

      <div className="d-flex flex-column gap-15">
        <div className="h-1px bg-off-white"></div>
        {stage_1_review ? (
          <div className="d-flex gap-10 align-items-center">
            <div className="bg-teal-muted border-1 border-solid border-black radius-8px min-w-70px text-center fs-13 fw-400 lh-22px">
              Stage 1
            </div>
            <div className="d-flex flex-column flex-lg-row gap-10 gap-mobile-3 align-items-lg-center">
              <div className="fs-16 fw-700 text-black">
                Personal Details & Interview
              </div>
              <div className="fs-13 fw-400 text-grey-dark">
                {stage_1_review} to review
              </div>
            </div>
          </div>
        ) : "" }
        {stage_2_review ? (
          <div className="d-flex gap-10 align-items-center">
            <div className="bg-teal-muted border-1 border-solid border-black radius-8px min-w-70px text-center fs-13 fw-400 lh-22px">
              Stage 2
            </div>
            <div className="d-flex flex-column flex-lg-row gap-10 gap-mobile-3 align-items-lg-center">
              <div className="fs-16 fw-700 text-black">Compliance Checks</div>
              <div className="fs-13 fw-400 text-grey-dark">
                {stage_2_review} to review
              </div>
            </div>
          </div>
        ) : "" }
        {stage_3_review ? (
          <div className="d-flex gap-10 align-items-center">
            <div className="bg-teal-muted border-1 border-solid border-black radius-8px min-w-70px text-center fs-13 fw-400 lh-22px">
              Stage 3
            </div>
            <div className="d-flex flex-column flex-lg-row gap-10 gap-mobile-3 align-items-lg-center">
              <div className="fs-16 fw-700 text-black">
                Documents & Contract
              </div>
              <div className="fs-13 fw-400 text-grey-dark">
                {stage_3_review} to review
              </div>
            </div>
          </div>
        ) : "" }
        <div className="d-flex gap-10 align-items-center">
          <div className="d-flex flex-column flex-lg-row gap-10 gap-mobile-3 align-items-lg-center">
              <div className="fs-16 fw-700 text-black">
                Request to Edit Profile
              </div>
              <div className="fs-13 fw-400 text-grey-dark">
                {edit_request_count} to review
              </div>
            </div>
        </div>
        <div className="d-flex gap-10 align-items-center">
          <div className="d-flex flex-column flex-lg-row gap-10 gap-mobile-3 align-items-lg-center">
              <div className="fs-16 fw-700 text-black">
                Compliance Alerts
              </div>
              <div className="fs-13 fw-400 text-grey-dark">
                {compliance_alerts_count} alert{compliance_alerts_count > 1 ? 's' : ''}{" "}({compliance_alerts_review_count} to review{compliance_alerts_review_count > 1 ? 's' : ''})
              </div>
            </div>
        </div>
      </div>

      {/* Candidate Cards */}
      {/* {candidates.map((candidate) => (
        <div
          key={candidate.id}
          className="bg-teal-pale border border-teal-dark radius-8px py-8px px-10px d-flex gap-10 align-items-center"
        >
          <div className="w-40px h-40px radius-40px">
            <img
              src={candidate.imageUrl}
              alt={candidate.name}
              width={40}
              height={40}
              className="img-responsive rounded-circle object-fit-cover"
            />
          </div>
          <div className="flex-grow-1 d-flex flex-column flex-lg-row gap-10 align-items-lg-center text-break">
            <div className="flex-grow-1 d-flex flex-column gap-3">
              <div className="d-flex gap-5 align-items-center flex-wrap">
                <div className="fs-16 fw-700 text-black">{candidate.name}</div>
                <div className="fs-13 fw-400 text-grey-medium">
                  Submitted {candidate.submittedDate}
                </div>
              </div>
              <div className="d-flex gap-5 align-items-center flex-wrap">
                <div className="fs-13 fw-400 text-black">
                  {candidate.qualifications}
                </div>
                <div className="d-flex gap-5 align-items-center">
                  <Location size={16} />
                  <div className="fs-13 fw-400 text-black">
                    Lives in {candidate.location}
                  </div>
                </div>
              </div>
            </div>
            <CustomButton
              variant="primary"
              type="button"
              className="btn-theme bg-teal text-black max-h-30px min-w-76px"
            >
              View
            </CustomButton>
          </div>
        </div>
      ))} */}
    </div>
  );
};

export default CandidateProfiles;
